/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderHpExportRoutingModule } from './builder-office-export-routing.module';
import { ExportOfficeComponent } from './components/office-export.component';
import { ExportOfficeBusinessService } from './resources/office-export-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderHpExportRoutingModule,
  ],
  providers: [
    ExportOfficeBusinessService,
  ],
  declarations: [
    ExportOfficeComponent,
  ],
})

export class BuilderHpExportModule {
}
